const encodeUri = (dataObj) => {
  const formBody = [];
  for (const key in dataObj) {
    formBody.push(`${encodeURIComponent(key)}=${encodeURIComponent(dataObj[key])}`);
  }
  return formBody.join('&');
};

export default encodeUri;
